import React, { Component } from "react";
import AuthService from "../../Services/Auth/AuthService";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";

export const AuthContext = React.createContext({
    signinRedirectCallback: (): void => { },
    logout: (): void => { },
    isAuthenticated: (): boolean => (false),
    signinRedirect: (_emailPrefill: string = null,_redirectUrl: string = null): void => { },
    staffSigninRedirect: (): void => { },
    signinSilentCallback: (): void => { },
    createSigninRequest: (): void => { },
    setOnBehalfOf: ({ }): void => { },
    getOnBehalfOf: (): string => (null),
    getAccessToken: (): Promise<string> => (null),
    changeEmail: ({}): Promise<Response> => (null),
    changePassword: ({ }): Promise<Response> => (null),
    register: ({}): Promise<boolean> => (null),
});

export const AuthConsumer = AuthContext.Consumer;

export class AuthProvider extends Component<any, any> {
    authService;
    constructor(props: any) {
        super(props);
        this.authService = new AuthService(props.errorPage);

        this.state = {
            isReady: false
        }
    }

    componentDidMount() {
        this.authService.initialize()
            .then(() => {
                this.setState({ isReady: true })
            });
    }

    render() {
        if (!this.state.isReady) {
            return <AbpnSpinner/>
        }
        return <AuthContext.Provider value={this.authService}>{this.props.children}</AuthContext.Provider>;
    }
}